import * as actionTypes from "./actionTypes";

import api from "../../services";
import messages from "../../constants/messages";
import { apiStart, apiSuccess } from "./apiActions";
import { errorHandler, catchHandler, successHandler } from "./responseHandler";
import { uploadScreenshot } from "./appointmentActions";

export const setTemplateData = payload => {
  return dispatch => {
    dispatch({
      type: actionTypes.SET_TEMPLATE_DATA,
      payload,
    });
  };
};

export const clearTemplateData = () => {
  return dispatch =>
    dispatch({
      type: actionTypes.CLEAR_TEMPLATE_DATA,
    });
};

export const addTemplateData = payload => {
  return dispatch =>
    dispatch({
      type: actionTypes.ADD_TEMPLATE,
      payload,
    });
};

export const addTemplatesNote = (cb = () => {}) => {
  return (dispatch, getState) => {
    const templates = getState()?.dashboard?.patients?.currentData;
    let notes = templates?.notes;
    let notesString = notes;

    const noteObj = templates;
    dispatch(apiStart());

    notesString = notesString?.replace(/<img[^>]*>/gi, "");

    if (
      noteObj?.chief_complaint === "" ||
      noteObj?.chief_complaint == undefined
    ) {
      noteObj.chief_complaint = null;
    }
    if (noteObj?.plan === "" || noteObj?.plan == undefined) {
      noteObj.plan = null;
    }
    if (noteObj?.assessment === "" || noteObj?.assessment == undefined) {
      noteObj.assessment = null;
    }
    if (notesString === "" || notesString == undefined) {
      notesString = null;
    }

    const payload = {
      note_name: noteObj?.note_name,
      chief_complaint: noteObj?.chief_complaint,
      notes: notesString,
      plan: noteObj?.plan,
      assessment: noteObj?.assessment,
    };
    api
      .addNoteTemplate(payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          dispatch(addTemplateData(res.data));
          successHandler(messages.NOTE_TEMPLATE_CREATED_SUCCESS);
          cb();
        } else {
          errorHandler(res.message[0]);
        }

        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const setAllTemplates = payload => {
  return dispatch => {
    dispatch({
      type: actionTypes.SET_ALL_TEMPLATE,
      payload,
    });
  };
};

export const emptyTemplateData = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.EMPTY_TEMPLATE_DATA,
    });
  };
};

export const getAllTemlates = (searchValue = "", page = 1) => {
  return (dispatch, getState) => {
    const templates = getState()?.dashboard?.templates?.all;

    dispatch(apiStart());
    api
      .getAllNoteTemplate(searchValue, page)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          const resp = res.data[0];
          const data =
            page > 1 ? [...templates, ...resp.results] : resp.results;

          dispatch(
            setAllTemplates({
              results: data,
              total_pages: resp.links.total_pages,
            })
          );
        } else {
          errorHandler(res.message[0]);
        }

        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const getTemplateById = id => {
  return dispatch => {
    dispatch({
      type: actionTypes.GET_TEMPLATE_BYID,
      payload: id,
    });
  };
};

export const updateTemplateById = payload => {
  return dispatch => {
    dispatch({
      type: actionTypes.UPDATE_TEMPLATE_BYID,
      payload,
    });
  };
};

export const editTemplateById = (tempID, cb = () => {}) => {
  return (dispatch, getState) => {
    const payload = getState()?.dashboard?.templates?.currentData;

    if (
      payload?.chief_complaint === "" ||
      payload?.chief_complaint == undefined
    ) {
      payload.chief_complaint = null;
    }
    if (payload?.plan === "" || payload?.plan == undefined) {
      payload.plan = null;
    }
    if (payload?.assessment === "" || payload?.assessment == undefined) {
      payload.assessment = null;
    }
    if (payload?.notes === "" || payload?.notes == undefined) {
      payload.notes = null;
    }

    dispatch(apiStart());
    api
      .editNoteTemplate(tempID, payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          dispatch(updateTemplateById(payload));
          successHandler(messages.NOTE_TEMPLATE_EDITED_SUCCESS);
          cb();
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const setEditMode = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.SET_EDIT_MODE,
    });
  };
};

export const clearEditMode = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.CLEAR_EDIT_MODE,
    });
  };
};

export const removeTemplateByID = payload => {
  return dispatch => {
    dispatch({
      type: actionTypes.REMOVE_TEMPLATE_BYID,
      payload,
    });
  };
};

export const deleteTemplateById = (tempID, cb = () => {}) => {
  return (dispatch, getState) => {
    dispatch(apiStart());
    api
      .deleteNoteTemplate(tempID)
      .then(response => {
        const res = response.data;
        if (res.status_code === 204) {
          successHandler(res.message[0]);
          dispatch(removeTemplateByID(tempID));
          cb();
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const templateSearch = payload => {
  return dispatch => {
    dispatch({
      type: actionTypes.SEARCH_TEMPLATE_DATA,
      payload,
    });
  };
};

export const searchTemplates = q => {
  return (dispatch, getState) => {
    const templates = getState()?.dashboard?.templates.all;
    if (templates?.length > 0) {
      const searchTemplates = templates.filter(x =>
        x.note_name?.toLowerCase()?.includes(q.toLowerCase())
      );

      dispatch(templateSearch({ searchValue: q, search: searchTemplates }));
    }
  };
};

export const setCurrentId = id => {
  return dispatch => {
    dispatch({
      type: actionTypes.SET_CURRENT_ID,
      id: id,
    });
  };
};

export const setViewMode = id => {
  return dispatch => {
    dispatch({
      type: actionTypes.SET_VIEW_MODE,
      id: id,
    });
  };
};

//screenshots
export const setScreenshots = url => {
  return dispatch => {
    dispatch({
      type: actionTypes.SET_SCREENSHOTS,
      payload: url,
    });
  };
};

export const clearScreenshots = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.CLEAR_SCREENSHOTS,
    });
  };
};

export const getImages = string => {
  const imgRex = /<img.*?src="(.*?)"[^>]+>/g;
  const images = [];
  let img;
  while ((img = imgRex.exec(string))) {
    images.push(img[1]);
  }
  return images;
};

export const getUrls = string => {
  const urlRex = /(https?:\/\/[^\s]+)/g;
  const urls = [];
  let url;
  while ((url = urlRex.exec(string))) {
    urls.push(url[1]);
  }
  return urls;
};

export const addNoteLock = (cb = () => {}) => {
  return (dispatch, getState) => {
    dispatch(apiStart());
    const templates = getState()?.dashboard?.templates;
    console.log(templates?.currentData?.notesImages,"templetes")
    const vitals = getState()?.dashboard?.ongoingAppointment?.vitals || {};

    const appointmentData =
      getState()?.dashboard?.appointments?.schAppointmentDetail;

    const visitNow =
      getState()?.dashboard?.ongoingAppointment?.currentAppointment;

    const appointment = {
      id: appointmentData?.id || visitNow?.appointment,
      patient_detail_id:
        appointmentData?.patient_detail?.id || visitNow?.patient?.id,
      visitNowId: visitNow?.id,
    };

    const notesImages = templates?.currentData?.notesImages;

    const noteObj = templates?.currentData;
    let notesString;
    if (notesImages.length > 0) {
      uploadScreenshot(notesImages, templates?.currentId, res => {
        res
          .then(imgUrl => {
            notesString = [templates?.currentData?.notes, ...imgUrl];

            const payload = {
              note_name: noteObj?.note_name,
              chief_complaint: noteObj?.chief_complaint,
              notes: notesString,
              plan: noteObj?.plan,
              assessment: noteObj?.assessment,
              appointment: appointment.id,
              visit_now: appointment?.visitNowId,
              patient: appointment.patient_detail_id,
              ...vitals,
            };
            api
              .addNotesLock(payload)
              .then(response => {
                const res = response.data;
                if (res.status_code === 200) {
                  successHandler(messages.NOTE_CREATED_SUCCESS);
                  cb();
                } else {
                  errorHandler(res.message[0]);
                }

                dispatch(apiSuccess());
              })
              .catch(error => {
                catchHandler(error, dispatch);
              });
          })
          .catch(err => console.log("error: ", err));
      });
    } else {
      if (
        templates?.currentData?.notes &&
        !templates?.currentData?.notes.includes(undefined)
      ) {
        notesString = [templates?.currentData?.notes];
      }

      const payload = {
        note_name: noteObj?.note_name,
        chief_complaint: noteObj?.chief_complaint,
        notes: notesString,
        plan: noteObj?.chief_complaint,
        assessment: noteObj?.assessment,
        appointment: appointment.id,
        visit_now: appointment?.visitNowId,
        patient: appointment.patient_detail_id,
        ...vitals,
      };
      api
        .addNotesLock(payload)
        .then(response => {
          const res = response.data;
          if (res.status_code === 200) {
            successHandler(messages.NOTE_CREATED_SUCCESS);
            cb();
          } else {
            errorHandler(res.message[0]);
          }

          dispatch(apiSuccess());
        })
        .catch(error => {
          catchHandler(error, dispatch);
        });
    }
  };
};

//add photos inisde notes element
export const appendImageinNotes = url => {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_IMAGES_INSIDE_NOTES,
      payload: url,
    });
  };
};

//remove photos inisde notes element
export const removeScreenshot = id => {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.REMOVE_IMAGES_FROM_NOTES,
      payload: id,
    });
  };
};

export const addNote = (cb = () => {}) => {
  return (dispatch, getState) => {
    let currentData = getState()?.dashboard?.patients?.currentData;
    let noteObj = currentData
    if (Object.keys(currentData).length === 0){
      currentData=getState()?.dashboard?.templates;   
      noteObj = currentData?.currentData;
    }
    const id = getState()?.dashboard?.patients?.patient?.id;
    let notesString;
    if (noteObj.length > 0) {
      uploadScreenshot(res => {
        res
          .then(imgUrl => {
            notesString = [currentData?.notes, ...imgUrl];
            if(typeof notesString == "undefined"){
              notesString=[noteObj?.notes,...imgUrl]
            }
            const payload = {
              note_name: noteObj?.note_name,
              chief_complaint: noteObj?.chief_complaint,
              notes: notesString,
              plan: noteObj?.plan,
              assessment: noteObj?.assessment,
              patient: id,
            };
            api
              .addNotesLock(payload)
              .then(response => {
                const res = response.data;
                if (res.status_code === 200) {
                  successHandler(messages.NOTE_CREATED_SUCCESS);
                  cb();
                } else {
                  errorHandler(res.message[0]);
                }

                dispatch(apiSuccess());
              })
              .catch(error => {
                catchHandler(error, dispatch);
              });
          })
          .catch(err => console.log("error: ", err));
      });
    } else {
      console.log("in else")
      if (
        currentData?.notes &&
        !currentData?.notes.includes(undefined)
      ) {
        notesString = [currentData?.notes];
        
        }
      if(typeof notesString == "undefined"){
        notesString=[noteObj?.notes]
      }
      const payload = {
        note_name: noteObj?.note_name,
        chief_complaint: noteObj?.chief_complaint,
        notes: notesString,
        plan: noteObj?.plan,
        assessment: noteObj?.assessment,
        patient: id,
      };
      api
        .addNotesLock(payload)
        .then(response => {
          const res = response.data;
          if (res.status_code === 200) {
            successHandler(messages.NOTE_CREATED_SUCCESS);
            cb();
          } else {
            errorHandler(res.message[0]);
          }

          dispatch(apiSuccess());
        })
        .catch(error => {
          catchHandler(error, dispatch);
        });
    }
  };
};

export const addTemplate = (cb = () => {}) => {
  return (dispatch, getState) => {
    const templates = getState()?.dashboard?.templates;

    let notes = templates?.currentData?.notes;
    let notesString = notes;

    const noteObj = templates?.currentData;
    dispatch(apiStart());

    notesString = notesString?.replace(/<img[^>]*>/gi, "");

    if (
      noteObj?.chief_complaint === "" ||
      noteObj?.chief_complaint == undefined
    ) {
      noteObj.chief_complaint = null;
    }
    if (noteObj?.plan === "" || noteObj?.plan == undefined) {
      noteObj.plan = null;
    }
    if (noteObj?.assessment === "" || noteObj?.assessment == undefined) {
      noteObj.assessment = null;
    }
    if (notesString === "" || notesString == undefined) {
      notesString = null;
    }

    const payload = {
      note_name: noteObj?.note_name,
      chief_complaint: noteObj?.chief_complaint,
      notes: notesString,
      plan: noteObj?.plan,
      assessment: noteObj?.assessment,
    };
    api
      .addNoteTemplate(payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          dispatch(addTemplateData(res.data));
          successHandler(messages.NOTE_TEMPLATE_CREATED_SUCCESS);
          cb();
        } else {
          errorHandler(res.message[0]);
        }

        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};